import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SuccessGallery from "./SuccessGallery"
import Rezorpay from "./Rezorpay"

// Lazy load components
const Home = lazy(() => import("./Home"));
const Courses = lazy(() => import("./Courses"));
const Notes = lazy(() => import("./Notes"));
const Scholarship = lazy(() => import("./Scholarship"));
const About = lazy(() => import("./About"));
const Contact = lazy(() => import("./Contact"));
const ExploreMore = lazy(() => import("./ExploreMore"));
const ViewDetail = lazy(() => import("./ViewDetail"));
const Adca = lazy(() => import("./Adca"));
const Explore = lazy(() => import("./Explore"));
const Tally = lazy(() => import("./Tally"));
const DTP = lazy(() => import("./DTP"));
const Web = lazy(() => import("./Web"));
const Programming = lazy(() => import("./Programming"));
const More = lazy(() => import("./More"));
const Gd = lazy(() => import("./Gd"));
const Ms = lazy(() => import("./Ms"));
const Py = lazy(() => import("./Py"));
const HN = lazy(() => import("./HN"));
const Typing = lazy(() => import("./Typing"));
const CCC = lazy(() => import("./CCC"));
const Sc = lazy(() => import("./Sc"));
const Income = lazy(() => import("./Income"));
const Disable = lazy(() => import("./disable"));
const Gs = lazy(() => import("./Gs"));
const DCA = lazy(() => import("./DCA"));
const US = lazy(() => import("./US"));
const Refund = lazy(() => import("./Refund"));
const Terms = lazy(() => import("./Terms"));
const Policy = lazy(() => import("./Policy"));
const StudentFo = lazy(() => import("./student-fo"));
const PaymentTest = lazy(() => import("./PaymentTest"));
const Certificate = lazy(() => import("./Certificate"));
const Result = lazy(() => import("./Result"));



function App() {
  return (
    <Router>
      <AuthProvider>
        <Navbar />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/scholarship" element={<Scholarship />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/ExploreMore" element={<ExploreMore />} />
            <Route path="/ViewDetail" element={<ViewDetail />} />
            <Route path="/Adca" element={<Adca />} />
            <Route path="/Explore" element={<Explore />} />
            <Route path="/Tally" element={<Tally />} />
            <Route path="/DTP" element={<DTP />} />
            <Route path="/Web" element={<Web />} />
            <Route path="/Programming" element={<Programming />} />
            <Route path="/More" element={<More />} />
            <Route path="/Gd" element={<Gd />} />
            <Route path="/Ms" element={<Ms />} />
            <Route path="/Py" element={<Py />} />
            <Route path="/HN" element={<HN />} />
            <Route path="/Typing" element={<Typing />} />
            <Route path="/CCC" element={<CCC />} />
            <Route path="/Sc" element={<Sc />} />
            <Route path="/Income" element={<Income />} />
            <Route path="/disable" element={<Disable />} />
            <Route path="/Gs" element={<Gs />} />
            <Route path="/DCA" element={<DCA />} />
            <Route path="/US" element={<US />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/success/gallery" element={<SuccessGallery />} />
            <Route path="/certificate" element={<Certificate />} />
            <Route path="/result" element={<Result />} />
            <Route path="/payment" element={<StudentFo />} />
            <Route path="/Rezorpay/:amount?/:course?" element={<Rezorpay />} />
            <Route path="/payment-test" element={<PaymentTest />} />
          </Routes>
        </Suspense>
        <Footer />
      </AuthProvider>
    </Router>
  );
}

export default App;
